<template>
  <div class="timer"
       :class="{
         '_accent': +days < 3
       }"
  >
    <div class="timer__inner">
      <div class="timer__col">
        <div class="timer__label">{{$tGlobal('Still relevant')}}</div>
        <div class="timer__clock">
          <div class="timer__clock-col">
            <div class="timer__clock-val">{{days}}</div>
            <div class="timer__label">{{$tGlobal('days', +days)}}</div>
          </div>
          <div class="timer__clock-col">
            <div class="timer__clock-val">{{hours}}</div>
            <div class="timer__label">{{$tGlobal('hours', +hours)}}</div>
          </div>
          <div class="timer__clock-col">
            <div class="timer__clock-val">{{minutes}}</div>
            <div class="timer__label">{{$tGlobal('minutes', +minutes)}}</div>
          </div>
        </div>
      </div>
      <div v-if="showResume" class="timer__col _response">
        <div class="timer__label"><span>{{$tGlobal('Responded')}}</span><b>{{respondedTimes}}
          {{$tGlobal('times', +respondedTimes)}}</b></div>
        <div v-if="responded"
             class="timer__responded-text">
          {{$tGlobal('You have already responded to this vacancy')}}
          &nbsp;<BaseSvg name="ico-question"
                         width="15"
                         height="15"/>
        </div>
        <template v-else-if="!isDisabled">
          <button v-if="isLogged"
                  @click.prevent="respondOnVacancy"
                  class="timer__btn-respond base-btn base-btn--green  specific-to-respond">
            <span class="base-btn__text">{{$tGlobal('To respond')}}</span>
          </button>
          <router-link-modified v-else
                                :to="{name: 'auth', query: {redirect: $route.fullPath}}"
                                class="timer__btn-respond base-btn base-btn--green  specific-to-respond">
            <span class="base-btn__text">{{$tGlobal('To respond')}}</span>
          </router-link-modified>
        </template>
        <button v-else
                type="button"
                @click.prevent="subscribeOnVacancy"
                class="timer__btn-respond base-btn base-btn--green  specific-to-respond">
          <span class="base-btn__text">{{ $tVacancy('Report about new vacancies') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {PARTNER, EMPLOYEE} from "../constants/usersTypes";
  import parseDate from "../helpers/parseDate";

  export default {
    name: "Timer",
    components: {

    },
    props: {
      vacancyId: {
        type: Number
      },
      responded: {
        type: Boolean,
        default: false
      },
      respondedTimes: {
        type: [String, Number],
        default: 0
      },
      endTime: {
        type: [Date, String, Number],
        required: true
      },
      vacancy: Object
    },
    data() {
      return {
        timer: null,
        timeDiff: 0,

        respondOnVacancyShow: false,
        subscribeOnVacancyShow: false,
      }
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      canSendResume() {
        return this.isLogged &&
            this.$store.state.user.profile &&
            (this.$store.state.user.profile.user_type === EMPLOYEE || this.$store.state.user.profile.user_type === PARTNER)
      },
      showResume() {
        return !this.isLogged || this.canSendResume
      },
      endTimeMS() {
        // t.setDate(t.getDate() + 2)
        // t.setHours(t.getHours() + 2)
        // t.setMinutes(t.getMinutes() + 2)
        return +(parseDate(this.endTime))
      },
      days() {
        const totalM = this.timeDiff / 1000 / 60
        return Math.floor(totalM / 60 / 24).toString().padStart(2, '0')
      },
      hours() {
        const totalM = this.timeDiff / 1000 / 60
        return Math.floor(totalM / 60 % 24).toString().padStart(2, '0')
      },
      minutes() {
        const totalM = this.timeDiff / 1000 / 60
        return Math.ceil(totalM % 60).toString().padStart(2, '0')
      },

      //  RESPOND
      isDisabled() {
        const relevant = this.vacancy[1] && this.vacancy[1].relevant || this.vacancy.relevant_until
        if (!relevant) return true

        const relevantDate = parseDate(relevant)
        return new Date() > relevantDate //ok
        // return new Date() < relevantDate //not-ok
      },
    },
    methods: {
      createTimer() {
        clearInterval(this.timer)

        this.setDif()
        this.timer = setInterval(() => {
          this.setDif()
        }, 1000)
      },
      setDif() {
        let currentTime = +(new Date())
        this.timeDiff = (new Date(this.endTimeMS) - currentTime) || 0

        if (this.timeDiff <= 0) {
          this.timeDiff = 0
          clearInterval(this.timer)
        }
      },
      respondOnVacancy() {
        this.$vModal.open('respond-on-vacancy', {
          vacancyId: this.vacancyId
        })
      },
      subscribeOnVacancy() {
        this.$vModal.open('subscribe-on-vacancy', {
          vacancyId: this.vacancyId
        })
      },
    },
    watch: {
      endTime() {
        this.createTimer()
      }
    },
    created() {
      this.createTimer()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>

<style>

</style>
